/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const LegalAgreementVariable = {
    UmbrellaLegalName: 'UMBRELLA_LEGAL_NAME',
    UmbrellaRegistrationNumber: 'UMBRELLA_REGISTRATION_NUMBER',
    SignatureDate: 'SIGNATURE_DATE'
} as const;
export type LegalAgreementVariable = typeof LegalAgreementVariable[keyof typeof LegalAgreementVariable];


export function instanceOfLegalAgreementVariable(value: any): boolean {
    for (const key in LegalAgreementVariable) {
        if (Object.prototype.hasOwnProperty.call(LegalAgreementVariable, key)) {
            // @ts-ignore
            if (LegalAgreementVariable[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function LegalAgreementVariableFromJSON(json: any): LegalAgreementVariable {
    return LegalAgreementVariableFromJSONTyped(json, false);
}

export function LegalAgreementVariableFromJSONTyped(json: any, ignoreDiscriminator: boolean): LegalAgreementVariable {
    return json as LegalAgreementVariable;
}

export function LegalAgreementVariableToJSON(value?: LegalAgreementVariable | null): any {
    return value as any;
}

